
import { Vue, Component } from 'vue-property-decorator';
import PickupInfo from '@/features/schedule-pickup/components/PickupInfo.vue';
import DoneToDashboardFooter from '@/features/common/components/DoneToDashboardFooter.vue';
import { ScheduledPickupItem } from '@/features/schedule-pickup/types';
import AttentionList, { ListType } from '@/features/common/components/AttentionList.vue';
import CancelPickupModal from '@/features/schedule-pickup/components/CancelPickupModal.vue';
import { getAScheduledPickup } from '@/features/pickup-history/services/pickupHistory.services';
import { GlobalResponseType } from '@/features/common/types';
import { getDisplayCarrierCode } from '@/features/common/helpers/carrier';

@Component({
  components: {
    PickupInfo,
    DoneToDashboardFooter,
    AttentionList,
    CancelPickupModal,
  },
})
export default class PickupConfirm extends Vue {
  private attentionList: ListType = {
    title: this.$t('scheduledPickups.pickupConfirmed.rememberPickupMissed') as string,
    list: [
      {
        text: this.$t('scheduledPickups.pickupConfirmed.notReschedulePickup') as string,
        icon: 'mdi-calendar-remove',
      },
      {
        text: this.$t('scheduledPickups.pickupConfirmed.notCallToReschedule') as string,
        icon: 'mdi-cellphone-remove',
      },
      {
        text: this.$t('scheduledPickups.pickupConfirmed.notCompensateDueToMissed') as string,
        icon: 'mdi-currency-usd-off',
      },
    ],
  }

  private showCancelModal = false;

  private pickupScheduledData: ScheduledPickupItem | null = null;

  get displayCarrierCode(): string {
    if (!this.pickupScheduledData) return '';
    return getDisplayCarrierCode(
      this.pickupScheduledData.carrierCode,
      this.pickupScheduledData.selectedService || '',
    );
  }

  private cancelPickupResponse: GlobalResponseType | null = null;

  private oopsShow = false;

  async created(): Promise<void> {
    this.$store.commit('setLoading', true);

    this.pickupScheduledData = await getAScheduledPickup(
      this.$route.query.id as string,
    );

    this.$store.commit('setLoading', false);
  }

  private cancelPickup(cancelPickupResponse: GlobalResponseType | null) {
    if (cancelPickupResponse && cancelPickupResponse.successful) {
      this.$router.replace({ name: 'pickup-schedule' });
      return;
    }
    this.cancelPickupResponse = cancelPickupResponse;
    this.oopsShow = true;
  }
}
